export class ContaAPagar {}
